import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import App from './App';
import reportWebVitals from './reportWebVitals';

interface ConfiguredClerkProviderProps {
  children: React.ReactNode;
  publishableKey: string;
  signInUrl: string;
  signUpUrl: string;
  signInForceRedirectUrl: string;
  signUpForceRedirectUrl: string;
  signInFallbackRedirectUrl: string;
  signUpFallbackRedirectUrl: string;
  afterSignOutUrl: string;
}

// Clerk 6's generated declaration omits browser script options under
// TypeScript 4.9, although the React provider still supports them at runtime.
const ConfiguredClerkProvider = ClerkProvider as unknown as React.ComponentType<ConfiguredClerkProviderProps>;

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPublishableKey) {
  throw new Error(
    'Missing REACT_APP_CLERK_PUBLISHABLE_KEY. Add it to the frontend environment before starting the app.'
  );
}

window.__clerk_publishable_key = clerkPublishableKey;

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ConfiguredClerkProvider
      publishableKey={clerkPublishableKey}
      signInUrl="/login"
      signUpUrl="/invitation"
      signInForceRedirectUrl="/dashboard"
      signUpForceRedirectUrl="/dashboard"
      signInFallbackRedirectUrl="/dashboard"
      signUpFallbackRedirectUrl="/dashboard"
      afterSignOutUrl="/"
    >
      <App />
    </ConfiguredClerkProvider>
  </React.StrictMode>
);

reportWebVitals(); 